import type { TowerAttachmentPoints, TowerFormValue } from '../types';

const limitOrZero = (limit: number | null | undefined): number => limit ?? 0;

export function deriveAttachmentPoints(form: TowerFormValue): TowerAttachmentPoints {
  let runningSum = limitOrZero(form.primary.limit);

  const underlying = form.underlying.map((layer) => {
    const attachment = runningSum;
    runningSum += limitOrZero(layer.limit);
    return attachment;
  });

  return {
    primary: 0,
    underlying,
    cowbell: runningSum,
    total: runningSum + limitOrZero(form.cowbell.limit),
  };
}
